export const getPathWithoutQueryString = (p: string) => {
  return p.split("?")[0];
};
